import * as Actions from '../actions';
import { createReducer } from '@reduxjs/toolkit';
import type { CommentState } from '~/types/redux/share';

const defaultState: CommentState = {
  comments: [],
  creating: false,
  errorMessage: null,
  focused: false,
  value: '',
};

const commentsReducer = createReducer(defaultState, (builder) => {
  builder.addCase(Actions.creatingComment, (state) => {
    state.creating = true;
    state.errorMessage = null;
  });

  builder.addCase(Actions.createdComment, (state, action) => {
    state.comments.push(action.payload);
    state.creating = false;
    state.value = '';
  });

  builder.addCase(Actions.errorCreatingComment, (state, action) => {
    state.creating = false;
    state.errorMessage = action.payload;
  });

  builder.addCase(Actions.commentTextChanged, (state, action) => {
    state.value = action.payload;
  });

  builder.addCase(Actions.commentFocusChanged, (state, action) => {
    state.focused = action.payload;
  });
});

export default commentsReducer;
